import axios from "axios";

export default {
    getCategories() {
        return axios.get(`/categories`);
    },
    getCategory(id) {
        return axios.get(`/categories/${id}`);
    },
    postCategory(obj) {
        return axios.post(`/categories`, obj);
    },
    putCategory(id, obj) {
        return axios.put(`/categories/${id}`, obj);
    },
    deleteCategory(id) {
        return axios.delete(`/categories/${id}`);
    },
    getIRICategories(){
        return axios.get(`/categories/liste`);
    }
};
